import { useState } from 'react';

import { BedroomsQuery } from '../../../../../apollo/__generated__/graphql';
import { useBedroomsQuery } from '../../../../hooks/useBedroomsQuery';
import { useRemoveBedroomFromPlaceMutation } from '../../../../hooks/useRemoveBedroomFromPlaceMutation';

export const useBedroomsDrawer = (placeId: string | null) => {
  const [editingBedroom, setEditingBedroom] = useState<
    BedroomsQuery['bedrooms'][number] | null
  >(null);
  const [bedroomToDeleteId, setBedroomToDeleteId] = useState<string | null>(
    null,
  );
  const [isCreateBedroomDrawerOpen, setIsCreateBedroomDrawerOpen] =
    useState<boolean>(false);
  const { data, loading } = useBedroomsQuery(placeId);

  const onShowDeleteDialog = (bedroomId: string) => {
    setBedroomToDeleteId(bedroomId);
  };
  const onCloseDeleteDialog = () => {
    setBedroomToDeleteId(null);
  };

  const { removeBedroomFromPlace } =
    useRemoveBedroomFromPlaceMutation(onCloseDeleteDialog);

  const onCreateBedroom = () => {
    setIsCreateBedroomDrawerOpen(true);
  };

  const onCreateBedroomDrawerClose = () => {
    setIsCreateBedroomDrawerOpen(false);
  };

  const onDeleteBedroom = () => {
    if (bedroomToDeleteId) {
      removeBedroomFromPlace(bedroomToDeleteId);
    }
  };

  const onEditBedroom = (bedroom: BedroomsQuery['bedrooms'][number]) => {
    setEditingBedroom(bedroom);
  };

  const onCloseEditBedroom = () => {
    setEditingBedroom(null);
  };

  const bedrooms = data?.bedrooms ?? [];
  return {
    bedrooms,
    isCreateBedroomDrawerOpen,
    onCreateBedroom,
    onCreateBedroomDrawerClose,
    loading,
    onShowDeleteDialog,
    onDeleteBedroom,
    onCloseDeleteDialog,
    bedroomToDeleteId,
    editingBedroom,
    onEditBedroom,
    onCloseEditBedroom,
  };
};
